module.exports = __webpack_public_path__ + "img/anuencia_ajuda.0100f441.jpg";